import { FDV_URL, IDUSUARIO, USERNAME, customAxios } from '../constants';
import { SAVE_GENERAR_CORREO_AUTORIZACIONES } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function saveGenerarCorreoAutorizaciones(
  codSolicitud,
  numFichaVtaVeh,
  numProfVeh,
  codEstadoAut,
  destinatarios,
  copia,
  tipoMensaje
) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME,
    }
  };

  const data = {
    codSolicitud: codSolicitud,
    numFichaVtaVeh: numFichaVtaVeh,
    numProfVeh: numProfVeh,
    codEstadoAut: codEstadoAut,
    destinatarios: destinatarios,
    copia: copia,
    tipoMensaje: tipoMensaje
  };

  const request = customAxios.post(`${FDV_URL}/autorizacion-excepcional/generar-correo`, data, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: SAVE_GENERAR_CORREO_AUTORIZACIONES,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/GenerarCorreoAutorizaciones.js